/* eslint-disable import/order */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
// Actions
import { layoutUpdate, loadPage } from 'src/actions/common';
import { addToCart, confirmItem } from './actions';
// Paths
import { replace, addSkuPath } from 'src/utils/paths';
// Constants
import { GOOGLE_AD_WORDS_TV_MOUNT_SKU_ID_DEFAULT } from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
import { PAGE_NAME } from './constants';
// Selectors
import pageSelectors from './selectors';
// Components
import { SplitHOC } from 'src/components/SplitIO/SplitHOC';
import withResolution from 'src/hoc/withResolution';
import { splitioConstants, useSplitIOTreatment } from 'src/components/SplitIO';
import PageLoader from 'src/components/PageLoader';
import { showFirstServiceDiscountModal } from 'src/components/HTKit/Modals/FirstServiceDiscount/actions';
import ErrorPage from 'src/containers/ErrorPage';
import AddSkuPageV2 from 'src/containers/AddSkuPageV2';
import AddSkuPage from './AddSkuPage';
import QuestionsFlowPage from './QuestionsFlowPage';

const ConditionalSplitLoader = ({ shouldLoad, splits = [] }) => {
  if (!shouldLoad || !splits.length) return null;
  splits.forEach((split) => useSplitIOTreatment(split));
  return null;
};
ConditionalSplitLoader.propTypes = { shouldLoad: PropTypes.bool, splits: PropTypes.array };

class AddSkuPageContainer extends Component {
  static propTypes = {
    layoutUpdate: PropTypes.func.isRequired,
    loadPage: PropTypes.func.isRequired,
    replace: PropTypes.func,
    showFirstServiceDiscountModal: PropTypes.func.isRequired,
    sku: PropTypes.object,
    cart: PropTypes.object,
    page: PropTypes.object.isRequired,
    pageLoading: PropTypes.bool,
    pageError: PropTypes.bool,
    item: PropTypes.object.isRequired,
    skuId: PropTypes.number.isRequired,
    isConfirmation: PropTypes.bool,
    email: PropTypes.string,
    isNewQAFlow: PropTypes.bool.isRequired,
    splitObject: PropTypes.shape({
      addskupageV2SplitTreatment: PropTypes.string.isRequired,
    }),
  };

  state = {
    itemTotalPrice: null,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.loadPage(PAGE_NAME, {
      id: this.props.skuId,
      email: this.props.email,
      isConfirmation: this.props.isConfirmation,
    });
  }

  componentDidUpdate(prevProps) {
    const oldSkuId = prevProps.skuId;
    const newSkuId = this.props.skuId;
    if (oldSkuId !== newSkuId) {
      this.props.loadPage(PAGE_NAME, {
        id: newSkuId,
        email: this.props.email,
        isConfirmation: this.props.isConfirmation,
      });
      this.props.replace(addSkuPath(newSkuId)); // Update URL pathing
    }
    if (
      this.props.item &&
      this.props.item.get('totalPrice') &&
      this.state.itemTotalPrice === null
    ) {
      this.setState({ itemTotalPrice: this.props.item.get('totalPrice') });
    }
  }

  componentWillUnmount() {
    this.props.showFirstServiceDiscountModal();
  }

  render() {
    const {
      page,
      pageLoading,
      pageError,
      sku,
      isConfirmation,
      isNewQAFlow,
      skuId,
      splitObject,
    } = this.props;
    if (pageLoading) return <PageLoader />;
    if (pageError || !sku) return <ErrorPage page={page} />;
    const { itemTotalPrice } = this.state;
    const propsToRender = { ...this.props, itemTotalPrice };

    /* "New QA" QuestionsFlowPage Split */
    const showNewSku = !isConfirmation && isNewQAFlow;

    /*
      GoogleAdsTVMount Split
      - Only load this split if the specific sku is requested. Cannot use the HOC here, because it loads the split 100% of the time.
    */
    const isGoogleAdsTvMountSku = Number(skuId) === GOOGLE_AD_WORDS_TV_MOUNT_SKU_ID_DEFAULT;
    const googleAdsTvMountSplits = [splitioConstants.SPLITIONAME_GOOGLE_ADS_TV_MOUNT_SKU];

    /*
      AddSkuPageV2 Split
      - We can use the SplitHOC for this because we want the split to load 100% of the time.
     */
    const isPartnerSku = sku.get('partner');
    const isV2SplitOn = splitObject.addskupageV2SplitTreatment === splitioConstants.ON;
    const showV2Version = isV2SplitOn && !isPartnerSku;
    const AddSkuPageVersion = showV2Version ? AddSkuPageV2 : AddSkuPage;

    return (
      <>
        <ConditionalSplitLoader
          shouldLoad={isGoogleAdsTvMountSku}
          splits={googleAdsTvMountSplits}
        />
        <Helmet title={`Order ${sku.get('name')}`} />
        {showNewSku ? (
          <QuestionsFlowPage {...propsToRender} />
        ) : (
          <AddSkuPageVersion {...propsToRender} />
        )}
      </>
    );
  }
}

export default connect(pageSelectors, {
  layoutUpdate,
  loadPage,
  addToCart,
  showFirstServiceDiscountModal,
  confirmItem,
  replace,
})(withResolution(SplitHOC(splitioConstants.SPLITIONAME_ADDSKUPAGE_V2)(AddSkuPageContainer)));
